import React, { forwardRef } from "react";
import Index from "../../Index";

const GrayBgButton = forwardRef((props, ref) => {
  const { className, onClick, btnLabel, imgsrc, subLabel } = props;
  return (
    <Index.Box className="gray-bg-btn-main">
      <Index.Button onClick={onClick} disableRipple className={className}>
       
        {subLabel ? (
           <Index.Box>
            <div className="button-content">
            <span className="btn-label">{btnLabel}</span>
            {subLabel && <span className="sub-label">{subLabel}</span>}
          </div>
           </Index.Box>
          
        ) : (
          btnLabel
        )}
        {imgsrc && <img src={imgsrc} alt="icon" />}
      </Index.Button>
    </Index.Box>
  );
});

export default GrayBgButton;
